import { useQuery } from '@tanstack/react-query'
import { listCreditTransactionHistory } from 'services/apiCreditTransactions'

const useListCreditTransaction = (page,page_size,searchTerm) => {
  
    const {isPending,isSuccess,isError,error,data} = useQuery({
        queryKey:['creditHistory',page,page_size,searchTerm],
        queryFn: ()=> listCreditTransactionHistory(page,page_size,searchTerm),
        keepPreviousData:true,
        staleTime: 2 * 60 * 60 * 1000
    })

    return{isPending,isSuccess,isError,error,data}
}

export default useListCreditTransaction
